"use client";

const SentryIntegration = () => {
  return null;
};

export default SentryIntegration;
